import React, { useState } from 'react';
import { Card, Typography, Divider, message, Button } from 'antd';
import { Link } from 'react-router-dom';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { DynamicForm, FormConfig } from '../../components/DynamicForm';

const { Title, Paragraph } = Typography;

// 示例表单配置
const exampleFormConfig: FormConfig = {
  id: 'example_form',
  name: '示例表单',
  description: '这是一个简单的示例表单，展示 DynamicForm 组件的使用方法',
  fields: [
    {
      key: 'name',
      label: '姓名',
      type: 'input',
      required: true,
      placeholder: '请输入姓名',
      rules: [
        { required: true, message: '请输入姓名' }
      ]
    },
    {
      key: 'age',
      label: '年龄',
      type: 'number',
      required: true,
      placeholder: '请输入年龄',
      rules: [
        { required: true, message: '请输入年龄' },
        { type: 'number', min: 1, max: 120, message: '年龄必须在1-120之间' }
      ]
    },
    {
      key: 'gender',
      label: '性别',
      type: 'select',
      required: true,
      placeholder: '请选择性别',
      options: [
        { label: '男', value: 'male' },
        { label: '女', value: 'female' },
        { label: '其他', value: 'other' }
      ],
      rules: [
        { required: true, message: '请选择性别' }
      ]
    },
    {
      key: 'birthday',
      label: '出生日期',
      type: 'date',
      required: false,
      placeholder: '请选择出生日期',
      props: {
        format: 'YYYY-MM-DD'
      }
    },
    {
      key: 'hobbies',
      label: '兴趣爱好',
      type: 'checkbox',
      required: false,
      options: [
        { label: '阅读', value: 'reading' },
        { label: '音乐', value: 'music' },
        { label: '运动', value: 'sports' },
        { label: '旅行', value: 'travel' },
        { label: '电影', value: 'movies' }
      ]
    },
    {
      key: 'introduction',
      label: '个人简介',
      type: 'textarea',
      required: false,
      placeholder: '请输入个人简介'
    }
  ]
};

const DynamicFormExample: React.FC = () => {
  const [formValues, setFormValues] = useState<Record<string, any>>({});

  // 处理表单提交
  const handleFormSubmit = (values: Record<string, any>) => {
    setFormValues(values);
    message.success('表单提交成功！');
    console.log('表单数据:', values);
  };

  return (
    <div style={{ padding: '24px' }}>
      <Card>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
          <Title level={2} style={{ margin: 0 }}>动态表单示例</Title>
          <Link to="/dynamic-form-nav">
            <Button icon={<ArrowLeftOutlined />}>
              返回导航页面
            </Button>
          </Link>
        </div>
        <Paragraph>
          这个页面展示了如何使用 DynamicForm 组件创建动态表单。
          DynamicForm 组件可以根据配置生成表单，支持多种字段类型和验证规则。
        </Paragraph>
        <Divider />

        <Title level={3}>表单示例</Title>
        <DynamicForm
          config={exampleFormConfig}
          onFinish={handleFormSubmit}
          mode="create"
        />

        {Object.keys(formValues).length > 0 && (
          <>
            <Divider />
            <Title level={3}>提交的数据</Title>
            <pre style={{ background: '#f5f5f5', padding: '16px', borderRadius: '4px' }}>
              {JSON.stringify(formValues, null, 2)}
            </pre>
          </>
        )}
      </Card>
    </div>
  );
};

export default DynamicFormExample; 